<template>
    <div id="campaign-preview" class="camp-preview mb-3">
        <div class="container my-4">
            <div class="row justify-content-md-center">
                <div class="col mb-3">
                    <CampCard :previewData="previewData" class="mx-auto"/>
                </div>
                <div class="col mb-3">
                    <UpdatesSchedule :previewData="previewData" class="mx-auto"/>
                </div>
                <div class="col">
                    <PromoInfoPrev :previewData="previewData" class="mx-auto"/>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import CampCard from './PreviewParts/CampCard.vue'
    import UpdatesSchedule from './PreviewParts/UpdatesSchedule.vue'
    import PromoInfoPrev from './PreviewParts/PromoInfoPrev.vue'
    import BreadCrumbs from "../Theme/BreadCrumbs";
    export default {
        name: "CampPreview",
        components: {
            CampCard,
            UpdatesSchedule,
            PromoInfoPrev,
            BreadCrumbs
        },
        props: {
            previewData: Object
        },
    }
</script>
<style>
    .camp-prev, .update-schedule, .promo-info-prev {
        height: 670px;
        width: 100%;
        max-width: 440px;
        border-radius: 10px;
        padding: 0 15px;
        box-shadow: 0px 0px 35px rgba(154, 161, 171, 0.15);
    }
    .camp-prev, .update-schedule {
        background: #FFFFFF;
    }
</style>